import * as React from "react";

export default function Loader() {
  return <img src="/static/atcc/logo.png" alt="ATCC logo" className="brand-logo" />;
}
